import { DefaultError, keepPreviousData, Query, QueryKey } from '@tanstack/react-query'

export const keepPreviousDataWithPlaceholder =
  <PlaceholderData = unknown>(placeholderData: PlaceholderData) =>
  <
    TQueryFnData = PlaceholderData,
    TError = DefaultError,
    TQueryData = TQueryFnData,
    TQueryKey extends QueryKey = QueryKey,
  >(
    previousData: TQueryData | undefined,
    _previousQuery: Query<TQueryFnData, TError, TQueryData, TQueryKey> | undefined,
  ): TQueryData | undefined => {
    if (previousData != null) return keepPreviousData(previousData)
    return placeholderData as unknown as TQueryData
  }
